import React, { useMemo } from "react";
import CustomCategoryDrawer from "../../containers/CampaignMappings/CustomCategoryDrawer";
import { Select, Skeleton, Typography } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { useGetCampaignMappingDropdownsWithOptionsQuery } from "../../redux/api/campaignMappings";
import { setSelectedCustomConfigCategory } from "../../redux/store/campaignMappingsSlice";

const CustomCategoryDropdowns = () => {

    const dispatch = useDispatch();
    const selectedClient = useSelector((state) => state.genericReporting.selectedDropdownValues['client_name'] || '');
    const selectedConfigNames = useSelector((state) => state.campaignMappingsUi.selectedCustomConfigNames || []);
    const selectedPerConfig = useSelector((state) => state.campaignMappingsUi.selectedCustomConfigCategories || {});

    const { data, isFetching, isError } = useGetCampaignMappingDropdownsWithOptionsQuery(
        { clientName: selectedClient },
        { skip: !selectedClient }
    );

    const categoriesByConfig = useMemo(() => {
        const map = {};
        if (Array.isArray(data)) {
            data.forEach((d) => {
                if (d?.config_name) {
                    map[d.config_name] = Array.isArray(d.categories) ? d.categories.filter(Boolean) : [];
                }
            });
        }
        return map;
    }, [data]);

    const renderOne = (configName) => {
        const options = (categoriesByConfig[configName] || []).map((c) => ({ label: c, value: c }));
        const value = Array.isArray(selectedPerConfig[configName]) ? selectedPerConfig[configName] : [];

        // Mirror DropdownContainer formatting
        if (isFetching) {
            return (
                <div key={configName} style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", marginLeft: "0.5vw", marginRight: "0.5vw", minWidth: "12vw" }}>
                    <h4 style={{ minHeight: "1.2em" }}><Skeleton.Input active size="small" style={{ width: '6vw', height: '1.2em' }} /></h4>
                    <Select mode="multiple" style={{ width: '12vw' }} placeholder="Select options" loading />
                </div>
            )
        }

        return (
            <div key={configName} style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                marginLeft: "0.5vw",
                marginRight: "0.5vw",
                minWidth: "12vw",
            }}>
                <h4>{configName}</h4>
                <Select
                    mode="multiple"
                    style={{ width: "12vw" }}
                    placeholder="Select options"
                    value={value}
                    onChange={(vals) => dispatch(setSelectedCustomConfigCategory({ configName, value: vals }))}
                    options={options}
                    popupMatchSelectWidth={false}
                    showSearch
                    allowClear
                    maxTagCount="responsive"
                />
            </div>
        );
    };

    if (isError || !data || data.length === 0) {
            return null;
        }

    return (
        <>
            <CustomCategoryDrawer />
            <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", justifyContent: "center", rowGap: "1vw" }}>
                {Array.isArray(selectedConfigNames) && selectedConfigNames.map((name) => renderOne(name))}
            </div>
        </>
    )

}

export default CustomCategoryDropdowns;